import { FlaskConical } from 'lucide-react';
import { useState } from 'react';
import { useI18n } from '../../i18n/I18nProvider';
import styles from './Shell.module.css';

/**
 * Deployment-level notice (council UX + tax decisions 2026-10-04; WORKING_PREVIEW_ORDER §1.4): shown
 * unless the build is explicitly marked production (VITE_DEPLOYMENT=production), so a missing setting
 * still shows it. It cannot be dismissed; pressing it reveals one more sentence.
 */
export const IS_PRODUCTION_DEPLOYMENT =
  (import.meta.env.VITE_DEPLOYMENT as string | undefined) === 'production';

export function TestEnvStrip({ compact = false }: { compact?: boolean }) {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  if (IS_PRODUCTION_DEPLOYMENT) return null;
  if (compact)
    return (
      <p className={styles.testEnvInline} data-testid="test-env-inline">
        <FlaskConical size={14} aria-hidden="true" />
        {t.testEnv.strip}
      </p>
    );
  return (
    <div className={styles.testEnv} data-testid="test-env-strip">
      <button
        type="button"
        className={styles.testEnvButton}
        aria-expanded={open}
        aria-label={`${t.testEnv.strip}. ${t.testEnv.more}`}
        onClick={() => setOpen((v) => !v)}
      >
        <FlaskConical size={15} aria-hidden="true" />
        <span>{t.testEnv.strip}</span>
      </button>
      {open ? (
        <p className={styles.testEnvDetail} data-testid="test-env-detail">
          {t.testEnv.detail}
        </p>
      ) : null}
    </div>
  );
}
